import { getCompanyNameValidator, getEmailValidator, getNameValidator } from 'validators';
export const validateFirstName = getNameValidator('First name', 'Please enter a first name');
export const validateLastName = getNameValidator('Last name', 'Please enter a last name');
export const validateEmail = getEmailValidator(undefined, 'Please enter an email address');
export const validateCompanyName = getCompanyNameValidator(undefined, 'Please enter a company name');